import React, { SVGProps } from 'react';

export const ThumbsUpOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.223 2.526 10.32 1.89 6.624 9.9H4.2A2.1 2.1 0 0 0 2.1 12v7.2c0 1.16.94 2.1 2.1 2.1h13.52a2.1 2.1 0 0 0 2.003-1.468l2.35-7.438c.67-2.127-.917-4.294-3.148-4.294H15.3V6.795a4.5 4.5 0 0 0-3.077-4.27ZM7.8 11.648l3.48-7.54.374.125A2.7 2.7 0 0 1 13.5 6.795V9.9h5.425a1.5 1.5 0 0 1 1.43 1.952l-2.348 7.438a.3.3 0 0 1-.286.21H7.8v-7.852ZM6 11.7v7.8H4.2a.3.3 0 0 1-.3-.3V12a.3.3 0 0 1 .3-.3H6Z"
    />
  </svg>
);
